// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.B4fiLMIvwteGZWY4v8tI {
  text-align: center;
  color: #5CCA54;
  font-size: 0;
}

.SDJiw2fOk1W4jzlbnHzw {
  font-size: 100px;
}`, "",{"version":3,"sources":["webpack://./src/views/Eligible/Modal/SuccessEligibleModal.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".icon {\n  text-align: center;\n  color: #5CCA54;\n  font-size: 0;\n}\n\n.materialIcons {\n  font-size: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `B4fiLMIvwteGZWY4v8tI`,
	"materialIcons": `SDJiw2fOk1W4jzlbnHzw`
};
export default ___CSS_LOADER_EXPORT___;
